import AltRouteIcon from '@mui/icons-material/AltRoute'
import ProxyCreate from './ProxyCreate'
import ProxyEdit from './ProxyEdit'
import ProxyList from './ProxyList'
import ProxyShow from './ProxyShow'

export default {
  list: ProxyList,
  create: ProxyCreate,
  show: ProxyShow,
  edit: ProxyEdit,
  icon: AltRouteIcon,
}
